module.exports = __webpack_public_path__ + "static/media/Graves.839eb7d1.png";